import type {
  SeatApplicationCreateInput,
  SeatApplicationGetAllResponse,
  SeatApplicationResponse,
  SeatApplicationUpdateInput,
} from '@govinity/validation/public';
import {
  type AttachmentCreateDto,
  type AttachmentGetPutSignedUrlResponseDto,
} from '@govinity/validation';

import { CrudApi } from './base';

export const PATH = '/seat-applications';

class SeatApplicationsApi extends CrudApi<
  SeatApplicationGetAllResponse,
  SeatApplicationResponse,
  SeatApplicationCreateInput,
  SeatApplicationUpdateInput
> {
  getPath() {
    return PATH;
  }

  attachments(seatApplicationId: number) {
    return new SeatApplicationAttachmentsApi(this.getPath(), seatApplicationId);
  }

  async submit(applicationId: number) {
    const { data } = await this.request({
      method: 'POST',
      url: `${this.getPath()}/${applicationId}/submit`,
    });

    return data;
  }

  async unsubmit(applicationId: number) {
    const { data } = await this.request({
      method: 'POST',
      url: `${this.getPath()}/${applicationId}/unsubmit`,
    });

    return data;
  }

  async withdraw(applicationId: number, termApplicationId: number) {
    await this.request({
      method: 'POST',
      url: `${this.getPath()}/${applicationId}/terms/${termApplicationId}/withdraw`,
    });
  }
}

class SeatApplicationAttachmentsApi extends CrudApi<
  unknown,
  unknown,
  AttachmentCreateDto,
  unknown
> {
  seatApplicationId: number;
  seatApplicationPath: string;

  constructor(seatApplicationPath: string, seatApplicationId: number) {
    super();

    this.seatApplicationId = seatApplicationId;
    this.seatApplicationPath = seatApplicationPath;
  }

  getPath() {
    return `${this.seatApplicationPath}/${this.seatApplicationId}/attachments`;
  }

  async getPutSignUrl(filename: string) {
    const { data } = await super.request<AttachmentGetPutSignedUrlResponseDto>({
      method: 'POST',
      url: `${this.getPath()}/put-signed-url`,
      data: { filename },
    });
    return data;
  }
}

export default new SeatApplicationsApi();
